import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import { func, string, node } from 'prop-types';
const Tabs = /*#__PURE__*/React.forwardRef(function Tabs(props, ref) {
  const {
    onChange,
    value,
    children: childrenProp
  } = props,
        others = _objectWithoutPropertiesLoose(props, ["onChange", "value", "children"]);

  const children = React.Children.map(childrenProp, child => {
    const childValue = child.props.value;
    if (childValue === undefined) return null;
    const selected = childValue === value;
    return /*#__PURE__*/React.cloneElement(child, {
      value: childValue,
      onChange,
      selected
    });
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, others, {
    ref: ref,
    role: "tablist"
  }), children);
});
process.env.NODE_ENV !== "production" ? Tabs.propTypes = {
  onChange: func,
  value: string,
  children: node
} : void 0;
export default Tabs;